export const apiConfig = {
    getFeedbackStatements: (submissionId: number): string => {
        throw new Error(`getFeedbackStatements api request URL not implemented to accept an id like ${submissionId}`);
    }
};
